import { useContext, useEffect, useState } from "react";
import { requester } from "App"; // 가정한 예시 API 호출 객체
import { AuthContext } from "providers/AuthProvider"; // 인증 컨텍스트
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box } from '@mui/material';
import OrderRequestTable from "./OrderRequestTable";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import P from "components/P";
import Container from "layouts/container/Container";
import Center from "layouts/wrapper/Center";

function VendorOrderRequestList() {
    const { userName } = useContext(AuthContext);
    const [orderRequestList, setOrderRequestList] = useState();

    useEffect(() => {
        let data = { userName: userName };
        
        if (userName) {
            requester.getFindAllOrderRequests(data, (result) => {
                
                setOrderRequestList(result.data);
            });
        }
    }, [userName]);

    // 중첩된 데이터를 문자열로 변환하는 함수
    const formatNestedData = (data) => {
        if (Array.isArray(data)) {
            return data.map(item => {
                if (typeof item === 'object') {
                    return formatNestedData(item); // 재귀적으로 객체 처리
                }
                return item;
            }).join(', ');
        } else if (typeof data === 'object') {
            return Object.entries(data).map(([key, value]) => {
                if (typeof value === 'object') {
                    return `${key}: ${formatNestedData(value)}`; // 재귀적으로 객체 처리
                }
                return `${key}: ${value}`;
            }).join(', ');
        }
        return data;
    };

    const styles = {
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            marginTop: '20px',
        },
        th: {
            backgroundColor: '#007bff',
            color: 'white',
            padding: '10px',
            border: '1px solid #ddd',
        },
        td: {
            padding: '10px',
            border: '1px solid #ddd',
            textAlign: 'left',
        }
    };

    return (
        <Container>
            <Container maxWidth={1200}>
                <Center width={"100%"} textAlign={"left"}>
                    <P font={"gmarketSansBold"} size={40}>주문발주내역</P>
                </Center>
                <VerticalFlex>

                    <FlexChild>
                        {
                            orderRequestList &&
                                orderRequestList.length > 0 ?
                                <OrderRequestTable orders={orderRequestList} />
                                :
                                <P>발주내역이 없습니다.</P>
                        }

                    </FlexChild>
                </VerticalFlex>
            </Container>
        </Container>

    );
}

export default VendorOrderRequestList;